export const CSS_VAR_TOOLTIP_BACKGROUND_COLOR = '--tooltip-background-color';
export const CSS_VAR_TOOLTIP_COLOR = '--tooltip-color';
export const CSS_TOOLTIP_ARROW_SIZE = 12;
